import { Routes } from '@angular/router';

export const REPORT_ROUTES: Routes = [
  {
    path: ':id',
    loadComponent: () => import('./components/view/report-view.component').then((m) => m.ReportViewComponent),
  },
  {
    path: '',
    loadComponent: () => import('./components/list/report-list.component').then((m) => m.ReportListComponent),
  },
];
